import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Chart } from 'angular-highcharts';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss'],
})
export class PieChartComponent {
  elements: any;
  pieChart!: Chart;
  chartInitialized: boolean = false;

  @ViewChild('pieChartContainer') pieChartContainer!: ElementRef;
  constructor(
    private router: Router,
    private tableService: DashboardService,
    private cdr: ChangeDetectorRef
  ) {}
  ngOnInit() {
    this.tableService.filterData$.subscribe((data) => {
      this.elements = data;
      if (this.elements) {
        localStorage.setItem('filterTableData', JSON.stringify(this.elements));
      }
    });

    this.loadData();
  }

  ngAfterViewInit() {
    this.pieChart = new Chart({
      chart: {
        type: 'pie',
        backgroundColor: '#dfdfdf',
        renderTo: this.pieChartContainer.nativeElement,
      },
      title: {
        useHTML: true,
        text: '  ',
        style: {
          color: '#808080',
        },
      },
      credits: {
        enabled: false,
      },
      colors: [
        '#ea9999',
        '#ffe599',
        '#b6d7a8',
        '#a4c2f4',
        '#dd7e6b',
        '#b4a7d6',
        '#76a5af',
      ],
      plotOptions: {
        pie: {
          borderColor: '#808080',
          borderWidth: 1,
        },
      },
      series: [
        {
          type: 'pie',
          name: 'Segment',
          data: [],
        },
      ],
      accessibility: {
        enabled: false,
      },
    });
    this.chartInitialized = true;
    this.loadData();
  }
  loadData() {
    if (!this.chartInitialized) {
      setTimeout(() => {
        this.loadData();
      }, 100);
      return;
    }

    const storeData = localStorage.getItem('filterTableData');
    const parsedData = storeData ? JSON.parse(storeData) : null;
    if (parsedData) {
      const segments: string[] = Array.from(new Set(parsedData.map((data:any) => data.segment))) as string[];
      const segmentsCount: { [key: string]: number } = {};

      segments.forEach((segment) => {
        segmentsCount[segment] = parsedData.filter(
          (data: any) => data.segment === segment
        ).length;
      });
      const pieChartData = Object.entries(segmentsCount).map(
        ([segment, count]) => [segment, count]
      );
      if (this.pieChart && this.pieChart.ref && this.pieChart.ref.series) {
        this.pieChart.ref.series[0].setData(pieChartData);
      }
      this.cdr.detectChanges();
    }
  }
  backClick() {
    this.router.navigate(['/home']);
  }
}
